module.exports = __webpack_public_path__ + "img/menu-approval-active.c4eec862.svg";